import React from 'react';
import { Sparkles, Send, Paperclip, Smile } from 'lucide-react';

export default function ChatPreview() {
  return (
    <div className="chatCard">
      <div className="chatCard__header">
        <div className="chatCard__brand">
          <span className="chatCard__logo">
            <Sparkles size={14} />
          </span>
          <div>
            <div className="chatCard__title">AINA Assistant</div>
            <div className="chatCard__status">
              <span className="chatCard__statusDot" /> Online · WhatsApp
            </div>
          </div>
        </div>
        <div className="chatCard__channels">
          <span className="chip chip--green">WA</span>
          <span className="chip chip--pink">IG</span>
          <span className="chip chip--blue">FB</span>
        </div>
      </div>

      <div className="chatCard__body">
        <div className="bubble bubble--in">
          Hi! 👋 I'm looking for a 2-bedroom apartment for rent in downtown.
        </div>
        <div className="bubble bubble--out">
          Great choice! I have 3 listings under $2,500 available this week. Could I get your
          name and preferred move-in date so I can shortlist them for you?
        </div>
        <div className="bubble bubble--in">Alex, June 15th would be ideal.</div>
        <div className="bubble bubble--out">
          Perfect, Alex. Logging this in our CRM and sending you 3 matches now —
          would you like to book a viewing tomorrow at 4pm?
        </div>
        <div className="bubble bubble--meta">
          <span className="bubble__pill">Lead · New ➜ Qualified</span>
          <span className="bubble__pill bubble__pill--alt">📅 Appointment proposed</span>
        </div>
      </div>

      <div className="chatCard__input">
        <Paperclip size={16} />
        <span>Type a message…</span>
        <Smile size={16} />
        <button className="chatCard__send" aria-label="send">
          <Send size={14} />
        </button>
      </div>

      <div className="floatingCard floatingCard--top">
        <div className="floatingCard__icon" style={{ background: '#e0f7fe', color: '#06b6ec' }}>⚡</div>
        <div>
          <div className="floatingCard__title">Response time</div>
          <div className="floatingCard__value">1.2s avg</div>
        </div>
      </div>

      <div className="floatingCard floatingCard--bottom">
        <div className="floatingCard__icon" style={{ background: '#dcfce7', color: '#22c55e' }}>↑</div>
        <div>
          <div className="floatingCard__title">Lead conversions</div>
          <div className="floatingCard__value">+62% this week</div>
        </div>
      </div>
    </div>
  );
}
